<template>
    <div 
        class="card-container"
    >
        <a-card
            hoverable
            bordered
            :style="{
                width: '300px'
            }"
        >   
            
            <img v-if="imageSrc"
                slot="cover"
                :src="imageSrc"
            />

            <a-card-meta>   
                <a-icon slot="avatar"
                    v-if="imageSrc"
                    type="picture"
                    :style="{
                        fontSize: '35px'
                    }"
                />
                <a-icon slot="avatar"
                    v-if="!imageSrc"
                    type="file-unknown"
                    :style="{
                        fontSize: '35px'
                    }"
                />

                <template slot="title"
                    v-if="!editing"
                >
                    <div class="ant-card-meta-title">
                        {{ fileObj.nice_name }}
                    </div>
                </template>
                <template slot="title"
                    v-if="editing"
                >
                    <a-input
                        v-model="editedBeautyName"
                    />
                </template>

                <div slot="description">
                    <div class="description-holder">
                        {{ fileObj.name }}
                    </div>
                    <div class="extra-actions"
                        v-if="editing"
                    >
                        <a-button
                            :disabled="!editedBeautyName"
                            v-on:click="saveEdit"
                            size="small"
                            type="primary"
                            :style="{
                                marginRight: '10px'
                            }"
                        >
                        Ok
                        </a-button>

                        <a-button
                            v-on:click="cancelEdit"
                            size="small"
                        >
                            Mégse
                        </a-button>
                    </div>
                </div>
            </a-card-meta>

            <template class="card-actions"
                slot="actions"
            >
                <a-icon type="edit" 
                    v-on:click="() => this.setEditing(true)"
                />
                <a-icon type="delete" 
                    v-on:click="removeFile"
                />
            </template>
        </a-card>
    </div>
</template>

<script>

export default {


    props: {
        fileObj: Object,
        fileIndex: Number
    },

    data() {
        return {
            editedBeautyName: this.fileObj.nice_name,
            imageSrc: '',
            editing: false
        }        
    },

    created() {
        let imageType = this.fileObj.type;
        if (imageType.match(/image\/*/g)) { 
            this.loadImage();
        }
    },

    computed: {

    },

    methods: {
        loadImage() {
            let originFile = this.fileObj.originFileObj;
            let reader = new FileReader();
            reader.readAsDataURL(originFile);
            reader.onloadend = (e) => {
                this.imageSrc = reader.result;
            }
        },

        setEditing(status) {
            this.editing = status;
        },

        removeFile() {
            this.$emit('removeFile', this.fileIndex)
        },
        
        saveEdit() {

            this.$emit('fileObjChange', {
                ix: this.fileIndex,
                changedValues: {
                    nice_name: this.editedBeautyName,
                }
            });
            this.setEditing(false);
            this.editedBeautyName = this.fileObj.nice_name
        },
        
        cancelEdit() {
            this.setEditing(false);

            this.editedBeautyName = this.fileObj.nice_name
        }
    }
}
</script>

<style lang="scss" scoped>
    .primary-color {
        border-color: $primary-blue
    }
    .description-holder {
        margin-bottom: 10px;
        color: black;
    }
    .card-container {
        transition: all 0.2s ease-in-out;
        // width:300px;
        // height:600px;
        margin-left:auto;
        margin-right: auto;
    }
    .extra-actions {
        border-top: 1px solid #e8e8e8;
        padding-top: 15px;
    }
</style>
